import React from 'react';
import { NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { actionCreators, selectors } from '../store/modules/User';

const NavMenu = (props) => {
  const {
    requestLogout, requestUcsVersion, isAdmin, isAuthenticated,
  } = props;

  return (
    <div id="gaas-sidebar-menu">
      {/* <LinkContainer to="/" exact
        className="link">
        <NavItem>Mājas</NavItem>
      </LinkContainer> */}
      {isAuthenticated
        && isAdmin && (
          <LinkContainer to="/user" className="link">
            <NavItem>Lietotāji</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated
        && isAdmin && (
          <LinkContainer to="/publication" className="link">
            <NavItem>Publikācijas</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated
        && isAdmin && (
          <LinkContainer to="/branch" className="link">
            <NavItem>Kafejnīcas</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated
        && isAdmin && (
          <LinkContainer to="/coupon-campaign" className="link">
            <NavItem>Kuponu Izsūtīšana</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated
        && isAdmin && (
          <LinkContainer to="/email" className="link">
            <NavItem>E-pasti</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated
        && !isAdmin && (
          <LinkContainer to="/profile" className="link">
            <NavItem>Profils</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated
        && !isAdmin && (
          <LinkContainer to="/coupon" className="link">
            <NavItem>Kuponi</NavItem>
          </LinkContainer>
      )}
      {isAuthenticated && (
        <LinkContainer to="/#" exact
          onClick={() => requestLogout()} className="link">
          <NavItem>Iziet</NavItem>
        </LinkContainer>
      )}
      {!isAuthenticated && (
        <LinkContainer to="/register" className="link">
          <NavItem>Reģistrēties</NavItem>
        </LinkContainer>
      )}
      {!isAuthenticated && (
        <LinkContainer to="/login" className="link">
          <NavItem>Ienākt</NavItem>
        </LinkContainer>
      )}
      <br />
      <hr />
      {isAuthenticated
        && isAdmin && (
          <li className="link">
            <button type="button" className="form-control ucs-version"
              onClick={() => requestUcsVersion()}>
          UCS Versija
            </button>
          </li>

      )}
    </div>
  );
};

NavMenu.propTypes = {
  requestLogout: PropTypes.func.isRequired,
  requestUcsVersion: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
};

NavMenu.defaultProps = {
  isAdmin: false,
};

export default connect(
  state => ({
    router: state.router,
    isAdmin: selectors.getIsAdmin(state),
    isAuthenticated: selectors.getIsAuthenticated(state),
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(NavMenu);



// WEBPACK FOOTER //
// ./src/containers/NavMenu.jsx